import { render } from "./HomeTransactionsTable.vue?vue&type=template&id=4b4b89d0&scoped=true"
import script from "./HomeTransactionsTable.vue?vue&type=script&lang=js"
export * from "./HomeTransactionsTable.vue?vue&type=script&lang=js"

import "./HomeTransactionsTable.vue?vue&type=style&index=0&id=4b4b89d0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b4b89d0"

export default script